import i18n from 'i18next';
import { hiddenKeysConfig } from './hidden-keys-config';
import { ENV_CONFIG } from '@/constants';
import { encode } from 'js-base64';
import md5 from 'js-md5';

export const isHiddenFnImpl = key => {
  // 默认隐藏，如果有不隐藏的情况，根据 key 单独处理
  if (hiddenKeysConfig.includes(key)) {
    return true;
  }
  return false;
};

export const replaceFnImpl = (key, value, props) => {
  // 工作台中默认原样返回
  return props;
};

export const replaceTxtFnImpl = (key, txt) => {
  switch (key) {
    case 'use_customized_name':
      return i18n.t('来鼓');
    case 'setting-assign-rule-model-defaultUrlType':
      return 'type-source';
    case 'redbook_comment_base_url':
      return ENV_CONFIG.JAVA_API_URL;
    case 'authorized_sigin_redbook_route':
      return '/opendock/open-api/login';
    case 'auth_agree_auth_replace_route':
      return '/opendock/open-api/redbook/auth_token';
    case 'processor_help_center_url':
      return 'https://laigu.com/help/';
    case 'processor_known_more_link':
      return 'https://laigu.com/help/';
    case 'auth_register_success_btn':
      return '开始使用';
    case 'datascreen_time_chat_visit':
      return '每小时累计对话趋势';
    case 'agree_auth_agreement':
      return 'https://laigu.com/agreements/';
    case 'agree_auth_privacy_clause':
      return 'https://laigu.com/privacy/';
    case 'processor_enterprise_chat_link':
      return 'https://laigu.com/chatlink.html?';
    case 'processor_online_chat_link':
      return 'https://laigu.com/chatlink.html?subSource=sub_source_9';
    case 'online_service_chat_line_17_7':
      return 'sub_source_7';
    case 'payment_tab_marketing_robot_url':
      return 'sub_source_5';
    case 'online_service_chat_line_22_9':
      return 'sub_source_9';
    case 'processor_logo_url':
      return 'ecoboost-iconfontlaigu1';
    case 'redbook_auth_redirect_url':
      return ENV_CONFIG.runEnv === 'PROD'
        ? 'https://app.laigu.com/setting/redbook'
        : 'https://app-qa.laigu.com/setting/redbook';
    case 'register_company_info':
      return 'Copyright © 成都呼声科技有限责任公司';
    case 'register_beian_info':
      return '川公网安备 51019002006554号';
    case 'register_company_ICP':
      return '蜀ICP备2024079335号-1';
    case 'agent_high_assign':
      return '生成对话并分配到首次接待客服';
    case 'assign_rule_modal_addTips':
      return '按指定对象可分配时分配对话';
    case 'redbook_help_url':
      return ' https://laigu.com/docs/21/';
    case 'interface_password_encode':
      return encode(md5(txt));
    case 'processor_auto_rule_url':
      return 'https://laigu.com/docs/rules1/';
    case 'setting_conv_tag_link':
      return 'https://laigu.com/docs/tables1/';
    case 'setting_iframe_help_link':
      return 'https://laigu.com/docs/iframe1/';
    case 'processor_apis_link':
      return 'https://laigu.com/docs/apis-v2-0/';
    case 'processor_webhooks_url':
      return 'https://laigu.com/docs/webhooks/';
    case 'auth_identity_service_link':
      return 'https://laigu.com/agreements/';
    case 'quick_reply_card_view_logo':
      return 'ecoboost-iconfontlaigu2';
    case 'processor_utp_check':
      return 'https://app.laigu.com,https://eco-push-api-agent.laigu.com';
    default:
      // 工作台中默认原样返回
      return txt;
  }
};

export const replaceDataFnImpl = (key, originData) => {
  switch (key) {
    case 'time_chart_legend_config':
      return excludeDataInfo(originData, 'key', ['hourUvCnt']);
    case 'time_chart_list':
      return excludeDataInfo(originData, 'type', ['新访客数']);
    case 'inspection-home-navData':
      return excludeDataInfo(originData, 'key', ['setting/call']);
    case 'setting-agent_assign-gTypes':
      return keepDataInfo(originData, 'value', ['type-source', 'type-card']);
    case 'use-rule-detail-dependTypes':
      return keepDataInfo(originData, 'value', [
        'client_card',
        'client_tag',
        'conversation_source',
        'conversation_agent'
      ]);
    case 'custom_main_right_source':
      return keepDataInfo(originData, 'value', ['openCenter']);
    case 'customer_card_drawer_tab_list':
      return excludeDataInfo(originData, 'key', ['ticket']);
    case 'report_clue_acquisition_dimensions_tabs':
      return excludeDataInfo(originData, 'alias', ['web_channel']);
    case 'report_agent_service_colums':
      return excludeDataInfo(originData, 'title', [i18n.t('评价')]);
    case 'chat_left_chat_setting_modal':
      return excludeDataInfo(originData, 'id', ['chatCard']);
    case 'business_visitor_block':
      return excludeDataInfo(originData, 'value', ['ticket', 'newTicket']);
    case 'history_main_left_filter_form':
      return excludeDataInfo(originData, 'value', [
        'region',
        'source_v2_visit_source',
        'platform',
        'evaluation_level',
        'conv_page',
        'source_page',
        'landing_page',
        'keyword',
        'true_keyword',
        'ip'
      ]);
    case 'history_main_right_column_config_list':
      return excludeDataInfo(originData, 'value', ['referrer', 'landing_page', 'source_page', 'utm', 'visit']);
    case 'home_page_block_day_group_list':
      return excludeDataInfo(originData, 'title', ['评价', '留言']);
    case 'home_page_block_day_group_list_data':
      return excludeDataInfo(originData, 'value', ['queued_clients']);
    case 'automatic_rule_edit_source':
      return keepDataInfo(originData, 'name', ['redbook', 'douyin', 'quickhand', 'wx_video']);
    case 'agent_assign_rule_modal_source':
      return keepDataInfo(originData, 'value', ['redbook', 'douyin', 'quickhand', 'wx_video']);
    case 'customer_open_center_source':
      return keepDataInfo(originData, 'value', ['redbook', 'douyin', 'quickhand', 'wx_video']);
    case 'role_tab_category':
      return excludeDataInfo(originData, 'mark', ['call', 'ticket', 'robot', 'call_robot']);
    case 'role_tab_online_config_setting':
      return excludeArrayInfo(originData, [
        'config_queuing',
        'auto_push',
        'config_prechat_survey',
        'config_conv_intercept',
        'config_evaluation',
        'config_custom_message'
      ]);
    case 'role_tab_online_child':
      return excludeDataInfo(originData, 'mark', ['online_ticket', 'online_security']);
    case 'role_tab_inspection_child':
      return excludeDataInfo(originData, 'mark', ['call']);
    case 'role_tab_monitor_child':
      return excludeDataInfo(originData, 'mark', ['call']);
    case 'role_tab_report_online':
      return excludeArrayInfo(originData, [
        'see_conv_queue',
        'see_conv_traffic',
        'see_site_keyword',
        'see_agent_evaluation'
      ]);
    case 'role_tab_report_child':
      return excludeDataInfo(originData, 'mark', ['call', 'newTicket', 'ticket']);
    case 'role_tab_public_access':
      return keepArrayInfo(originData, ['config_redbook', 'config_douyin']);
    case 'chat_left_setting_modal_right_type':
      return excludeDataInfo(originData, 'value', ['intelligentRecommend']);
    case 'quick_reply_edit_page_nav_setting':
      return excludeDataInfo(originData, 'value', ['1', '2']);
    case 'chat_setting_modal_custom_conv':
      return excludeDataInfo(originData, 'value', ['visitor', 'queue']);
    default:
      // 工作台中默认原样返回
      return originData;
  }
};

const excludeDataInfo = (originData, keyName, excludeValues) => {
  const filteredData = originData.filter(item => {
    if (excludeValues.includes(item[keyName])) {
      return false;
    }
    return true;
  });
  return filteredData;
};

const keepDataInfo = (originData, keyName, keepValues) => {
  const filteredData = originData.filter(item => {
    if (keepValues.includes(item[keyName])) {
      return true;
    }
    return false;
  });
  return filteredData;
};

const excludeArrayInfo = (originData, excludeValues) => {
  const filteredData = originData.filter(item => {
    if (excludeValues.includes(item)) {
      return false;
    }
    return true;
  });
  return filteredData;
};

const keepArrayInfo = (originData, keepValues) => {
  const filteredData = originData.filter(item => {
    if (keepValues.includes(item)) {
      return true;
    }
    return false;
  });
  return filteredData;
};
